export default "__VITE_ASSET__4hcbhpXj__"